import hideSidebar from './hideSidebar';
import showSidebar from './showSidebar';

export default {
  hideSidebar,
  showSidebar,
};
